import {createContext} from "react";

const RequestListContext = createContext();

export default RequestListContext;